import { Icon } from '@iconify/react/dist/iconify.js';
import { Leaderboard, QuestionAnswer } from '@mui/icons-material';
import { Container, Paper } from '@mui/material';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuthUser from '../../hooks/useAuthUser';

const navStyle = { 
    '&.Mui-selected' : {
        color: 'var(--dark-green)'
    },
};

export default function BottomNav() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    var { isNewUser }  = useAuthUser();

    const [value, setValue] = useState(pathname);
    const navTo = (path) => {
        navigate(path);
    }
    if (isNewUser) return <></>;
    return (
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
            <Container maxWidth={'xs'}>
            <BottomNavigation
                value={value}
                onChange={(event, newValue) => {
                    setValue(newValue);
                    navTo(newValue)
                }}
            >
                <BottomNavigationAction 
                    label="Score" 
                    icon={<Icon icon="mage:id-card-fill" fontSize={'1.7em'}/>}
                    value={'/profile/edit'}
                    sx={navStyle}
                />
                <BottomNavigationAction 
                    label="Rewards" 
                    icon={<Icon icon="fa6-solid:gift" fontSize={'1.4em'} />} 
                    value={'/profile/rewards'}
                    sx={navStyle}
                />
                <BottomNavigationAction 
                    label="Home" 
                    icon={<Icon icon="teenyicons:home-solid" fontSize={'1.8em'} />} 
                    value={'/'}
                    sx={navStyle}
                />
                <BottomNavigationAction 
                    label="Leaderboard" 
                    icon={<Leaderboard />} 
                    value={'/profile/leaderboard'}
                    sx={navStyle}
                />
                <BottomNavigationAction 
                    label="Feedback" 
                    icon={<QuestionAnswer />} 
                    value={'/feedback'}
                    sx={navStyle}
                />
            </BottomNavigation>
            </Container>
        </Paper>
    );
}
